(() => {
  const WHATSAPP_SELECTOR = '.doto-whatsapp-float';
  const GAP = 12;
  const EDGE = 8;

  let frame = 0;
  let resizeObserver = null;
  let observedGorgias = null;

  const isVisible = (element) => {
    if (!element || !element.isConnected) return false;

    const rect = element.getBoundingClientRect();
    if (rect.width < 12 || rect.height < 12) return false;

    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) !== 0;
  };

  const findGorgiasLauncher = () => {
    const selectors = [
      '.doto-gorgias-launcher',
      '.doto-home-gorgias-launcher',
      '#gorgias-chat-container iframe#chat-button',
      'iframe#chat-button',
      '#chat-button'
    ];

    for (const selector of selectors) {
      const matches = document.querySelectorAll(selector);
      for (const element of matches) {
        if (isVisible(element)) return element;
      }
    }

    return null;
  };

  const observeGorgiasSize = (launcher) => {
    if (!('ResizeObserver' in window) || launcher === observedGorgias) return;

    resizeObserver?.disconnect();
    observedGorgias = launcher;

    if (!launcher) return;

    resizeObserver = new ResizeObserver(() => scheduleSync());
    resizeObserver.observe(launcher);
  };

  const syncPosition = () => {
    frame = 0;

    const whatsapp = document.querySelector(WHATSAPP_SELECTOR);
    if (!whatsapp) return;

    const gorgias = findGorgiasLauncher();
    observeGorgiasSize(gorgias);

    if (!gorgias) {
      /* Se mantienen los fallbacks CSS mientras Gorgias termina de cargar. */
      whatsapp.style.removeProperty('left');
      whatsapp.style.removeProperty('right');
      whatsapp.style.removeProperty('top');
      whatsapp.style.removeProperty('bottom');
      return;
    }

    const gorgiasRect = gorgias.getBoundingClientRect();
    const whatsappRect = whatsapp.getBoundingClientRect();
    const whatsappWidth = whatsappRect.width || 56;

    const centeredLeft = Math.max(
      EDGE,
      Math.min(
        window.innerWidth - whatsappWidth - EDGE,
        gorgiasRect.left + ((gorgiasRect.width - whatsappWidth) / 2)
      )
    );

    /* bottom = distancia desde el borde inferior hasta la parte superior
       de Gorgias + separacion. Asi WhatsApp queda exactamente encima. */
    const bottom = Math.max(
      EDGE,
      window.innerHeight - gorgiasRect.top + GAP
    );

    whatsapp.style.setProperty('top', 'auto', 'important');
    whatsapp.style.setProperty('right', 'auto', 'important');
    whatsapp.style.setProperty('left', `${Math.round(centeredLeft)}px`, 'important');
    whatsapp.style.setProperty('bottom', `${Math.round(bottom)}px`, 'important');
  };

  function scheduleSync() {
    if (frame) return;
    frame = window.requestAnimationFrame(syncPosition);
  }

  const init = () => {
    scheduleSync();

    const observer = new MutationObserver(() => scheduleSync());
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    window.addEventListener('resize', scheduleSync, { passive: true });
    window.addEventListener('orientationchange', scheduleSync, { passive: true });
    window.addEventListener('scroll', scheduleSync, { passive: true });
    window.addEventListener('gorgias-widget-loaded', scheduleSync);

    /* Gorgias puede inyectarse despues del load. Estos reintentos evitan
       que el icono se quede un instante en la posicion fallback. */
    [250, 700, 1500, 3000, 6000].forEach((delay) => {
      window.setTimeout(scheduleSync, delay);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
